import { render, staticRenderFns } from "./changeInfo.vue?vue&type=template&id=87988be2&scoped=true&"
import script from "./changeInfo.vue?vue&type=script&lang=js&"
export * from "./changeInfo.vue?vue&type=script&lang=js&"
import style0 from "./changeInfo.vue?vue&type=style&index=0&id=87988be2&prod&scoped=true&lang=css&"
import style1 from "./changeInfo.vue?vue&type=style&index=1&id=87988be2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87988be2",
  null
  
)

export default component.exports